<script setup>
</script>

<template>
  <span class="credere-tags">
    <slot />
  </span>
</template>

<style lang="scss">
  .credere-tags {
    --gap: var(--token-spacing-micro);

    align-items: flex-start;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: flex-start;
  }
</style>
